import { CITATION_PILL_CLASS } from '../constants';
import type { NumberedLink } from '../utils/markdownLinks';

/**
 * The inline citation wherever the number cannot open the source panel: the PDF export, whose
 * headless capture has no pointer, and any surface rendering the report without a panel beside
 * it. The number is itself the anchor, so it stays the way to reach the source.
 */
export const InlineCitationStatic = ({ link }: { link: NumberedLink }) => (
  // Shares the `inline-citation` hook with the interactive variant: a caller asking whether the
  // prose cites its sources means either. `inline-citation-static` pins this shape specifically.
  <a
    href={link.url}
    target="_blank"
    rel="noopener noreferrer"
    aria-label={`${link.number} ${link.domain}`}
    data-testid="inline-citation"
    className="no-underline"
  >
    <span data-testid="inline-citation-static" className={CITATION_PILL_CLASS}>
      {link.number}
    </span>
  </a>
);
